import { io } from "socket.io-client"
// userService is no longer needed here for the connection itself

class SocketService {
  socket

  connect() {
    if (this.socket && this.socket.connected) {
      return
    }

    // 1. Get the token from localStorage
    const authToken = localStorage.getItem("token")

    if (!authToken) {
      console.error("SocketService: Kein Authentifizierungs-Token gefunden, Verbindung wird nicht hergestellt.")
      return
    }

    // 2. Pass the token in the 'auth' object when connecting
    this.socket = io({
      path: "/api/live/",
      auth: {
        token: authToken,
      },
    })

    this.socket.on("connect", () => {
      console.log(`🚀 WebSocket sicher verbunden! Socket ID: ${this.socket.id}`)
      // The old, insecure emit("join_room") is no longer needed and is REMOVED.
    })

    this.socket.on("connect_error", (err) => {
      console.error(`WebSocket-Verbindungsfehler: ${err.message}`)
      // This can happen if the token is expired or invalid.
      // You could trigger a logout here.
    })
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
    }
  }

  // Methode, um auf Events zu lauschen
  on(eventName, callback) {
    if (this.socket) {
      this.socket.on(eventName, callback)
    }
  }

  off(eventName) {
    if (this.socket) {
      this.socket.off(eventName)
    }
  }
}

export default new SocketService()
